import { render, staticRenderFns } from "./picEditType.vue?vue&type=template&id=0047f37d&scoped=true&"
import script from "./picEditType.vue?vue&type=script&lang=js&"
export * from "./picEditType.vue?vue&type=script&lang=js&"
import style0 from "./picEditType.vue?vue&type=style&index=0&id=0047f37d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0047f37d",
  null
  
)

component.options.__file = "picEditType.vue"
export default component.exports